import React from 'react';
import { Col } from 'react-bootstrap';
import Skeleton from '../../../common/skeleton';
const GridSkeleton = () => {
  return (
    <>
      <Col className="p-0">
        <div className="claim-list-grid">
          <Col>
            <Skeleton
              count={10}
              height={12}
              className="plan-details-skeleton"
            />
          </Col>
        </div>
      </Col>
    </>
  );
};

export default GridSkeleton;
